export default __webpack_public_path__ + "19b996e2ecbebaf2472c52ca42827c16.png";